module.exports = __webpack_public_path__ + "static/media/hm-testimonial-2.6db3662b.png";